module.exports = "<section class=\"ui-card card-hoverable\"\r\n    ng-click=\"$ctrl.generar()\">\r\n  <div class=\"kd-item padding-md\">\r\n    <i class=\"fa fa-fw fa-lg fa-file-pdf-o\"></i>\r\n    <div class=\"--text-bold flex\">Renuncia voluntaria</div>\r\n  </div>\r\n</section>\r\n<app-ui-document\r\n    ng-if=\"$ctrl.url\"\r\n    src=\"$ctrl.url\"\r\n    name=\"Renuncia voluntaria\"\r\n    on-close=\"$ctrl.url = null\"></app-ui-document>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/finiquito/components/escenario/documentos/renuncia/template.html
// module id = 972
// module chunks = 0